import { IWarningInfo } from '@vfit/shared/models';

export const configCMS = (obj: IWarningInfo) => ({
  title: obj.title || '',
  subtitle: obj.subtitle || '',
  description:
    obj.description || '',
});

